import { render } from "./World.vue?vue&type=template&id=2ced1554&scoped=true"
import script from "./World.vue?vue&type=script&lang=js"
export * from "./World.vue?vue&type=script&lang=js"

import "./World.vue?vue&type=style&index=0&id=2ced1554&scoped=true&lang=scss"

import exportComponent from "/builds/arena/frontend/game-maplestory-landing/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ced1554"]])

export default __exports__